import { useState, type FormEvent } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthShell from "@/pages/auth/components/AuthShell";
import { resolveNextDestination, DEFAULT_DESTINATION } from "@/lib/supabase";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const from = (location.state as { from?: string } | null)?.from;

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // دخول مباشر: أي إيميل وباسورد يفتح اللوحة فوراً بدون ربط بالإدارة
    localStorage.setItem("lumaa_demo_access", "1");
    navigate(resolveNextDestination(from) || DEFAULT_DESTINATION, { replace: true });
  };

  const inputClass =
    "h-[52px] w-full rounded-[14px] border border-[#E4F5F5] bg-[#EFFFFF] px-4 text-sm text-ghasla-text-heading outline-none transition-colors focus:border-[#0D6E6E]";

  return (
    <AuthShell
      title="تسجيل الدخول"
      subtitle="اكتب أي بريد وكلمة مرور للدخول"
      brandTitle="لوحة تحكم مقدم الخدمة"
      brandSubtitle="أدر طلباتك وخدماتك وتقاريرك من مكان واحد"
      showHighlights={false}
      centerContent
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="mb-2 block text-sm font-medium text-ghasla-text-primary">البريد الإلكتروني</label>
          <input
            type="email"
            className={inputClass}
            dir="ltr"
            placeholder="you@company.sa"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-ghasla-text-primary">كلمة المرور</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              className={`${inputClass} pl-11`}
              dir="ltr"
              placeholder="أدخل كلمة المرور"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              className="absolute left-3 top-1/2 flex h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-lg text-ghasla-text-secondary transition-colors hover:text-ghasla-text-link"
              aria-label="إظهار كلمة المرور"
            >
              <i className={`${showPassword ? "ri-eye-off-line" : "ri-eye-line"} text-lg`} />
            </button>
          </div>
          <div className="mt-2 flex justify-end">
            <Link
              to="/auth/forgot-password"
              className="text-[13px] font-medium text-ghasla-text-link hover:underline"
            >
              نسيت كلمة المرور؟
            </Link>
          </div>
        </div>

        <button
          type="submit"
          className="h-[52px] w-full cursor-pointer rounded-[14px] bg-gradient-to-l from-[#00AAB7] to-[#00C4CF] text-base font-bold text-white shadow-glow transition-opacity hover:opacity-90"
        >
          دخول
        </button>

        <p className="pt-1 text-center text-[13px] text-ghasla-text-secondary">
          أي بريد وكلمة مرور سيفتحان لوحة التحكم مباشرة
        </p>
      </form>
    </AuthShell>
  );
}